import RBAC from "@/api/rbac";

export default {
  mounted(el, binding) {
    const v = binding?.value;
    let ok = true;
    if (typeof v === "string") ok = RBAC.hasPerm(v);
    else if (v?.all) ok = RBAC.hasAll(v.all);
    else if (v?.any) ok = RBAC.hasAny(v.any);
    if (!ok) el.remove();
  },
  updated(el, binding) {
    // nếu quyền load sau
    const v = binding?.value;
    let ok = true;
    if (typeof v === "string") ok = RBAC.hasPerm(v);
    else if (v?.all) ok = RBAC.hasAll(v.all);
    else if (v?.any) ok = RBAC.hasAny(v.any);
    el.style.display = ok ? "" : "none";
  },
};
